import { push } from '@lagunovsky/redux-react-router'
import { initGiftVoucherBasket, postMealVoucher } from 'components/Basket/reducer'
import { findCinemaId } from 'global/helpers'
import { paymentStart, setGoPayVariant, setPayment } from 'pages/OrderSummary/reducer'
import { connect } from 'react-redux'

const mapStateToProps = (state) => {
    const cinemaid = findCinemaId(state)
    const { firstname, lastname, phone, email } = state?.services?.user || {}

    return {
        basket: state?.components?.basket?.data ?? null,
        cinemaid,
        isAuthorized: state?.services?.auth?.isAuthorized,
        userAuthInfo: { firstname, lastname, phone, email },
        goPayVariant: state?.pages?.orderSummary?.goPayVariant,
    }
}

const mapDispatchToProps = {
    push,
    postMealVoucher,
    setPayment,
    paymentStart,
    setGoPayVariant,
    initGiftVoucherBasket,
}

const hocBuyTicketVoucher = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocBuyTicketVoucher
